// extracted by mini-css-extract-plugin
module.exports = {"screen":"loadingText__screen___2hCOL","message":"loadingText__message___jvzkx","dot":"loadingText__dot___ynjJX","loading":"loadingText__loading___oEbhn"};